import { useState } from "react";
import { toast } from "sonner";
import { Wand2, Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const FixFailedButton = ({ kit, count, reload, testId = "verify-autofix", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const unchecked = (kit.verification || []).some((i) => !i.web_checked);
  if (!count && !unchecked && kit.status !== "fixing") return null;
  const running = busy || kit.status === "fixing";
  const go = async () => {
    setBusy(true);
    try { await http.post(`/kits/${kit.id}/verification/autofix`); toast.success("Fixing — replacing failed venues with verified alternatives"); reload(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <button data-testid={testId} onClick={go} disabled={running} title="Correct mismatched facts and replace venues whose websites fail with verified alternatives"
      className={`inline-flex items-center gap-2 rounded-sm bg-[#2B2A26] px-4 py-1.5 text-sm text-white hover:bg-black disabled:opacity-60 ${className}`}>
      {running ? <Loader2 size={14} className="animate-spin" /> : <Wand2 size={14} />}
      {running ? (kit.progress?.current || "Fixing…") : count ? `Fix & replace (${count})` : "Web-verify venues"}
    </button>
  );
};

export const FixReport = ({ report }) => {
  if (!report) return null;
  const { replaced = [], renamed = [], removed = [], unresolved = [], corrected = 0, url_fixed = 0, accepted = 0, web_checked = 0 } = report;
  return (
    <div data-testid="fix-report" className="mb-5 rounded-xl border border-emerald-200 bg-emerald-50/60 p-4 text-sm text-stone-700">
      <div className="font-medium text-[#2B2A26]">Last fix</div>
      <div className="mt-1 text-xs text-stone-600">{web_checked} venues web-checked · {url_fixed} websites corrected · {replaced.length} replaced · {renamed.length} renamed · {removed.length} removed · {corrected} facts corrected · {accepted} confirmed (site blocks robots)</div>
      {replaced.length > 0 && <ul className="mt-2 space-y-0.5 text-xs">{replaced.map((r) => <li key={r.from}>{r.from} → <b>{r.to}</b></li>)}</ul>}
      {renamed.length > 0 && <ul className="mt-2 space-y-0.5 text-xs">{renamed.map((r) => <li key={r.from}>Renamed: {r.from} → <b>{r.to}</b></li>)}</ul>}
      {removed.length > 0 && <div className="mt-2 text-xs text-stone-600">Removed (no verified alternative): {removed.join(", ")}</div>}
      {unresolved.length > 0 && <div data-testid="fix-unresolved" className="mt-2 text-xs text-amber-700">No verified replacement found for: {unresolved.join(", ")} — review manually.</div>}
    </div>
  );
};
